import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';

interface LiveClockProps {
  format?: string;
  ticking?: boolean;
  timezone?: string;
}

function LiveClock({
  format = 'HH:mm',
  ticking = true,
  timezone = 'UTC',
}: LiveClockProps) {
  const [time, setTime] = useState(() => moment.tz(timezone).format(format));

  useEffect(() => {
    if (!ticking) return;

    const interval = setInterval(() => {
      setTime(moment.tz(timezone).format(format));
    }, 1000);

    return () => clearInterval(interval);
  }, [format, ticking, timezone]);

  return <time>{time}</time>;
}

export default LiveClock;
